const ErrorBanner = ({ message }) => {
    if (!message) return null;
  
    const bannerStyle = {
      backgroundColor: '#FEE2E2', // Light red background
      color: '#B91C1C',           // Deep red text
      padding: '0.5rem 1rem',     // Vertical and horizontal padding
      textAlign: 'center',        // Centered text
      fontSize: '0.875rem',       // Roughly text-sm
      fontWeight: 500             // Medium font weight
    };
  
    return <div style={bannerStyle}>{message}</div>;
  };
  
  export default ErrorBanner;
  